var map = {
	"./dbt.png": 25227,
	"./logo.png": 70149,
	"./ronghe.png": 51370,
	"./ronghe_xz.png": 31500,
	"./shixiang.png": 68367,
	"./shixiang_xz.png": 54598,
	"./shouye.png": 14603,
	"./shouye_xz.png": 86567,
	"./sousuo.png": 22432,
	"./tx.png": 60502,
	"./xiaoxi.png": 908,
	"./xinwen.png": 53951,
	"./xinwen_xz.png": 41290,
	"./xitong.png": 92910,
	"./xitong_xz.png": 42274,
	"./xzkk.png": 73901,
	"./yingyong.png": 42997,
	"./yingyong_xz.png": 31455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93246;